import { render, staticRenderFns } from "./HeaderBonusesInfo.vue?vue&type=template&id=30ff16e0&"
import script from "./HeaderBonusesInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderBonusesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports